webpackJsonp([15],{

/***/ 1293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_table_run__);





var assignToMinibar = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _ref2, brand, model, token;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$http.get('//products.japisale.com' + '/p/brands/default');

					case 2:
						_ref2 = _context.sent;
						brand = _ref2.data;
						model = {
							warehouseId: this.id,
							entryDate: new Date(),
							details: this.rows.filter(function (row) {
								return row.isSelected;
							}).map(function (newRow) {
								var detail = {
									brandId: brand.id,
									productId: newRow.id,
									quantity: newRow.quantity,
									minStock: newRow.minStock
								};
								return detail;
							})
						};

						if (!(model.details.length > 0)) {
							_context.next = 13;
							break;
						}

						token = window.localStorage.getItem('housekeeping::token');
						_context.next = 9;
						return this.$http.post('//products.japisale.com' + '/v2/transfer-movement', model, {
							headers: {
								authorization: 'Bearer ' + token
							}
						});

					case 9:
						this.showNotification('Los productos se asignaron correctamente al minibar.', 'success');
						this.$router.push({ name: 'transfer-list' });
						_context.next = 14;
						break;

					case 13:
						this.showNotification('Debe seleccionar por lo menos un producto.');

					case 14:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function assignToMinibar() {
		return _ref.apply(this, arguments);
	};
}();

var changePage = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(value) {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						this.page = value;
						this.loadData();

					case 2:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function changePage(_x) {
		return _ref3.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						params = {
							flagActive: this.flagActive,
							limit: this.limit,
							page: this.page
						};

						if (this.search) {
							params.search = this.search;
						}
						if (this.sortField) {
							params.sortField = this.sortField;
						}
						if (this.sortDirection) {
							params.sortDirection = this.sortDirection;
						}
						_context3.next = 6;
						return this.$http.get('//products.japisale.com' + '/p/products/minibar', { params: params });

					case 6:
						response = _context3.sent;

						this.totalPages = Number(response.headers.get('x-last-page'));
						this.rows = response.data.map(function (data) {
							var newData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data);
							newData.quantity = 1;
							newData.minStock = 0;
							return newData;
						});

					case 9:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadData() {
		return _ref5.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	this.loadData();
}

function absolute(val) {
	this.rows = this.rows.map(function (row) {
		var newRow = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, row);
		if (row.minStock === val) {
			newRow.minStock = Math.abs(val);
		}
		return newRow;
	});
}

function assignText() {
	return this.$route.name === 'warehouses-products' ? 'almacén' : 'minibar';
}

function columnSortableEvent(_ref4) {
	var id = _ref4.id;

	var self = this;
	var newColumn = self.columns.filter(function (column) {
		return column.id === id;
	});
	newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map(function (columnSingle) {
		var newColumnSingle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, columnSingle);
		if (columnSingle.id !== newColumn[0].id && columnSingle.isSortable) {
			newColumnSingle.isSortable = { down: true, up: false };
		}
		return newColumnSingle;
	});
	this.sortField = newColumn[0].code;
	this.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
	this.loadData();
}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function searchByColumn(search) {
	this.search = search;
	this.page = 1;
	this.loadData();
}

function titleTransfer() {
	this.columns[1].name = this.$route.name === 'warehouses-products' ? 'Almacén' : 'Minibar';
	return this.$route.name === 'warehouses-products' ? 'Almacén' : 'Minibar';
}

function toInt(value) {
	var newValue = value.toString();
	if (!value) {
		this.showNotification('El valor para cantidad debe ser un número válido', 'error');
		this.isDisabled = true;
	} else if (value <= 0) {
		this.showNotification('El mínimo valor requerido es 1', 'error');
		this.isDisabled = true;
	} else if (newValue && newValue !== '' && newValue.indexOf('.') > -1) {
		this.showNotification('El valor para cantidad debe ser un número entero', 'error');
		this.isDisabled = true;
	} else {
		this.isDisabled = false;
	}
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		TableRun: __WEBPACK_IMPORTED_MODULE_5_table_run___default.a
	},
	computed: {
		assignText: assignText,
		pagesVisible: pagesVisible,
		titleTransfer: titleTransfer
	},
	created: created,
	data: function data() {
		return {
			columns: [{ id: 1, name: 'Nombre', code: 'name', isSortable: { down: true, up: false } }, { id: 2, name: '', code: 'w.name', isSortable: { down: true, up: false } }, { id: 3, name: 'Stock', code: 'stock', isSortable: { down: true, up: false } }, { id: 4, name: 'Cantidad', code: 'quantity' }, { id: 5, name: 'Stock Mínimo', code: 'minStock' }],
			flagActive: 1,
			href: { name: 'transfer-list' },
			isDisabled: false,
			limit: 10,
			page: 1,
			rows: [],
			totalPages: 5,
			search: null,
			sortDirection: null,
			sortField: null
		};
	},

	methods: {
		absolute: absolute,
		assignToMinibar: assignToMinibar,
		changePage: changePage,
		columnSortableEvent: columnSortableEvent,
		loadData: loadData,
		searchByColumn: searchByColumn,
		toInt: toInt
	},
	mixins: __WEBPACK_IMPORTED_MODULE_4__shared_mixins__["a" /* default */],
	name: 'minibar-products',
	props: ['id', 'name']
});

/***/ }),

/***/ 1403:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".title[data-v-56bbf450]{color:#353c4c;font-size:23px!important;text-align:left}.to-kardex[data-v-56bbf450]{color:inherit;font-family:inherit}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/minibar/Products.vue"],"names":[],"mappings":"AACA,wBACE,cAAe,AACf,yBAA2B,AAC3B,eAAiB,CAClB,AACD,4BACE,cAAe,AACf,mBAAqB,CACtB","file":"Products.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.title[data-v-56bbf450] {\n  color: #353c4c;\n  font-size: 23px !important;\n  text-align: left;\n}\n.to-kardex[data-v-56bbf450] {\n  color: inherit;\n  font-family: inherit;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1488:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1403);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("1f35af34", content, true);

/***/ }),

/***/ 1642:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md9": ""
    }
  }, [_c('h2', {
    staticClass: "title mb-0 mt-2"
  }, [_vm._v(_vm._s(_vm.titleTransfer) + ": " + _vm._s(_vm.name))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "text-xs-right": "",
      "mb-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-assign-tasks",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.assignToMinibar
    }
  }, [_vm._v("\n\t\t\t\tAsignar al " + _vm._s(_vm.assignText) + "\n\t\t\t")])], 1)], 1), _vm._v(" "), _c('table-run', {
    staticClass: "no-search-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": false,
      "include-switch": false,
      "include-settings": false,
      "include-delete-single": false,
      "key-value": "warehouseProductId"
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_c('router-link', {
          staticClass: "to-kardex",
          attrs: {
            "to": {
              name: 'kardex',
              params: {
                productId: props.row.id,
                productName: props.row.name,
                warehouseId: props.row.warehouseId
              }
            }
          }
        }, [_vm._v("\n\t\t\t\t\t" + _vm._s(props.row.name) + "\n\t\t\t\t")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.warehouseName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.stock))]), _vm._v(" "), _c('td', {
          staticClass: "pr-2"
        }, [_c('v-text-field', {
          staticClass: "time-standard-input",
          attrs: {
            "type": "number",
            "min": "1",
            "step": "1",
            "suffix": props.row.unitCode
          },
          on: {
            "keyup": function($event) {
              _vm.toInt(props.row.quantity)
            }
          },
          model: {
            value: (props.row.quantity),
            callback: function($$v) {
              props.row.quantity = $$v
            },
            expression: "props.row.quantity"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "pr-2"
        }, [_c('v-text-field', {
          staticClass: "time-standard-input stock",
          attrs: {
            "type": "number",
            "min": "1",
            "step": "1"
          },
          on: {
            "keyup": function($event) {
              _vm.absolute(props.row.minStock)
            }
          },
          model: {
            value: (props.row.minStock),
            callback: function($$v) {
              props.row.minStock = _vm._n($$v)
            },
            expression: "props.row.minStock"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPages),
      expression: "totalPages"
    }],
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "mt-3": ""
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": _vm.changePage
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1488)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1293),
  /* template */
  __webpack_require__(1642),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56bbf450",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/15.2c9117c5a148eb19377e.js